'use client';

import { Container, Skeleton, Stack, Box } from '@mui/material';
import { useSession } from 'next-auth/react';
export function LoadingCard() {
  return <Skeleton variant="rounded" height={400} data-sentry-element="Skeleton" data-sentry-component="LoadingCard" data-sentry-source-file="loading.tsx" />;
}
export default function Loading() {
  const {
    status
  } = useSession();
  return <Box sx={{
    mt: -4
  }} data-sentry-element="Box" data-sentry-component="Loading" data-sentry-source-file="loading.tsx">
      {status === 'authenticated' && <Skeleton variant="rectangular" width="100%" height={64} />}

      <Container sx={{
      mt: 4
    }} data-sentry-element="Container" data-sentry-source-file="loading.tsx">
        <Stack spacing={4} data-sentry-element="Stack" data-sentry-source-file="loading.tsx">
          <Skeleton variant="rounded" height={150} data-sentry-element="Skeleton" data-sentry-source-file="loading.tsx" />
          <LoadingCard data-sentry-element="LoadingCard" data-sentry-source-file="loading.tsx" />
        </Stack>
      </Container>
    </Box>;
}